/* Read More disclosures — smooth open/close for [data-readmore] <details>
   (feature-media + awards read-more, PDP More Details). Native <details>
   can't be height-animated with cross-browser CSS yet, so summary clicks
   are intercepted and the body's height (plus its paddings — border-box
   would otherwise snap at the end) is animated via WAAPI; the native
   `open` attribute lands as the final state. Reduced motion keeps the
   native jump-cut. */

(function () {
  if (window.__readMoreBound) return;
  window.__readMoreBound = true;

  var DURATION = 300;
  var EASING = 'ease-in-out';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('summary');
    if (!summary) return;

    var details = summary.parentElement;
    if (!details || !details.hasAttribute('data-readmore')) return;
    if (reducedMotion.matches) return;

    var body = null;
    for (var child = details.firstElementChild; child; child = child.nextElementSibling) {
      if (child.tagName !== 'SUMMARY') {
        body = child;
        break;
      }
    }
    if (!body || typeof body.animate !== 'function') return;

    event.preventDefault();
    if (details.dataset.animating === '1') return;
    details.dataset.animating = '1';

    var animateBody = function (from, to, onFinish) {
      body.style.overflow = 'hidden';
      var animation = body.animate([from, to], { duration: DURATION, easing: EASING });
      var settle = function () {
        body.style.overflow = '';
        delete details.dataset.animating;
        if (onFinish) onFinish();
      };
      animation.onfinish = settle;
      animation.oncancel = settle;
    };

    var measure = function () {
      var style = getComputedStyle(body);
      return {
        height: body.getBoundingClientRect().height + 'px',
        paddingTop: style.paddingTop,
        paddingBottom: style.paddingBottom
      };
    };

    var collapsed = { height: '0px', paddingTop: '0px', paddingBottom: '0px' };

    if (details.open) {
      animateBody(measure(), collapsed, function () {
        details.open = false;
      });
    } else {
      details.open = true;
      animateBody(collapsed, measure(), null);
    }
  });
})();
